import { TradeRestriction } from "@models/trading/tradeRestriction";

export class Trade {
  public id;
  public marketValueDisplayCurrency;
  public quantity;
  public costPrice;
  public price;
  public assetClassAllocation;
  public modelAllocation;

  public targetMarketValue;
  public buySellQuantity;
  public idealBuySell;
  public targetAssetClassAllocation;
  public targetModelAllocation;
  public hasActiveTradeSet;

  public cModelValue;

  public security;
  public cModelItem;
  public restriction;

  public constructor(tradeDTO: any) {
    this.id = tradeDTO.id;
    this.security = tradeDTO.security;
    this.restriction = tradeDTO.restriction ? new TradeRestriction(tradeDTO.restriction) : undefined;
    this.cModelItem = tradeDTO.cModelItem
    this.marketValueDisplayCurrency = tradeDTO.marketValueDisplayCurrency;
    this.quantity = tradeDTO.quantity;
    this.assetClassAllocation = tradeDTO.assetClassAllocation;
    this.modelAllocation = tradeDTO.modelAllocation;
    this.hasActiveTradeSet = tradeDTO.hasActiveTradeSet;

    this.costPrice = tradeDTO.costPrice;
    this.price = tradeDTO.price;

    this.targetMarketValue = tradeDTO.targetMarketValue ? +(+tradeDTO.targetMarketValue).toFixed(2) : 0;
    this.buySellQuantity = tradeDTO.buySellQuantity;
    this.idealBuySell = tradeDTO.idealBuySell;
    this.targetAssetClassAllocation = tradeDTO.targetAssetClassAllocation ? +(+tradeDTO.targetAssetClassAllocation).toFixed(2) : 0;
    this.targetModelAllocation = tradeDTO.targetModelAllocation ? +(+tradeDTO.targetModelAllocation).toFixed(2) : 0;
  }
}



// WEBPACK FOOTER //
// ./src/models/trading/trade.ts